import { Alert, ApiError, ERROR_TEXT, explain } from '@pryme/ui';
import { ERROR_GLOSSARY } from '../lib/glossary';
import type { ErrorCode } from '@pryme/protocol';

/** Explains ApiError (dashboard) and PrymeSdkError (signed calls) alike, with the protocol code. */
export function describeError(e: unknown): { code?: string; text: string } {
  if (e instanceof ApiError) return { code: e.code, text: explain(e) };
  const code = (e as { code?: string })?.code;
  const msg = e instanceof Error ? e.message : String(e);
  if (code) {
    const base = ERROR_TEXT[code] ?? ERROR_GLOSSARY[code as ErrorCode]?.meaning ?? code;
    return { code, text: msg && msg !== code ? `${base} (${msg})` : base };
  }
  return { text: explain(e) };
}

export function ErrorBox(props: { error: unknown }) {
  if (!props.error) return null;
  const d = describeError(props.error);
  const hint = d.code ? ERROR_GLOSSARY[d.code as ErrorCode]?.action : undefined;
  return (
    <Alert tone="bad">
      {d.code && <code className="p-mono-chip" style={{ marginRight: '0.4rem' }}>{d.code}</code>}
      {d.text}
      {hint && <div className="p-small" style={{ marginTop: '0.25rem' }}>What to do: {hint}</div>}
    </Alert>
  );
}
